import * as React from 'react';

import ApprovalsChangeContainer from '../../components/ApprovalsChange';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * クラス選択画面
 * @param props
 */
const ApprovalsChange: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('ApprovalsChange_0025')} />
			<ApprovalsChangeContainer {...props} />
		</>
	);
};

export default ApprovalsChange;



// WEBPACK FOOTER //
// ./src/pages/personal/ApprovalsChange.tsx